import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';

class TitlewContent extends Component{
	render(){
		return(
			<Row className="show-grid">
				<Col xs={12} md={12}>
					<a href={this.props.data.URL} target={this.props.data.OpenTarget}><img alt={this.props.data.MovieName} className="partner-image"src={this.props.data.ImagePath}/></a>
					<a className="partner-title-a" href={this.props.data.URL} target={this.props.data.OpenTarget}><h3 className="title">{this.props.data.MovieName}</h3></a>
					<p className="about-us-p">{this.props.data.ShortSynopsis}</p>
				</Col>
			</Row>	
		)
	}
}

export default TitlewContent;